import Yup from 'utils/yup'

import { ExpenseTypeEnum, PayableDocumentTypeEnum } from 'types/financial/payable'

export const defaultValues = {
  documentNumber: null,
  discount: 0,
  interest: 0,
  fine: 0,
  dueDate: null,
  observation: null,
  documentType: null,
}

export const validationSchema = Yup.object().shape({
  documentNumber: Yup.string().nullable().max(20, 'O número do documento deve ter no máximo 20 caracteres'),
  discount: Yup.number().required(),
  interest: Yup.number().required(),
  fine: Yup.number().required(),
  dueDate: Yup.date().nullable().required(),
  observation: Yup.string()
    .nullable()
    .max(500, 'As observações devem ter no máximo 500 caracteres')
    .test('observation', 'Observações não informadas', function (value) {
      if (!value && (this.parent.documentType === PayableDocumentTypeEnum.Others || this.parent.expenseType === ExpenseTypeEnum.Others)) return false
      return true
    }),
  documentType: Yup.string().nullable().required(),
})

export const paidDefaultValues = {
  paymentDate: null,
}

export const paidValidationSchema = Yup.object().shape({
  paymentDate: Yup.date().nullable().required(),
})
